export const environment = {
  production: false,
  skipAuthentication: true,
  useProdConfiguration: false,
};
